import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSingleOrderDetailsForCmm } from "../../../redux/slice/cmm/cmmSingleOrderSlice";
import { AppDispatch, RootState } from "../../../redux/store/store";

export const useSingleCmmOrder = (id: string | undefined) => {
  const dispatch = useDispatch<AppDispatch>();
  const { data: singleCmmOrderData, loading: singleCmmOrderDataLoading } =
    useSelector((state: RootState) => state.cmmSingleOrder);

  useEffect(() => {
    if (id) {
      dispatch(fetchSingleOrderDetailsForCmm(id));
    }
  }, [id]);

  return { singleCmmOrderData, singleCmmOrderDataLoading };
};
